import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { insertNewLine, generateKey } from '@/utils';
import Section from '../Section';
import media from '../../styles/media.style';
import { SCREEN_LOCKUP_WIDTH } from '../../styles/variables.style';

const Top = styled.div`
  margin: auto;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  width: 100%;

  ${media.tabletL`
    display: flex;
    justify-content: space-between;
    padding: 0 40px;
  `};

  ${media.desktop`
    padding: 0;
  `};
`;

const Title = styled.div`
  font-size: 24px;
  font-weight: 500;
  line-height: 1;
  letter-spacing: 0.2px;
  margin-bottom: 20px;

  ${media.tabletL`
    font-size: 32px;
    line-height: 1.19;
    margin-bottom: 40px;
    width: 45%;
  `};
`;

const Description = styled.div`
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.1px;

  ${media.tabletL`
    width: 45%;
  `};
`;

const Panels = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin: auto;
  max-width: 1280px;

  ${media.tabletL`
    padding: 0 40px;
  `};

  ${media.desktop`
    padding: 0;
  `};
`;

const Panel = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 500px;
  padding: 10px;

  ${media.tabletP`
    width: 50%;
  `};

  ${media.tabletL`
    width: calc(100% / 3);
  `};

  ${media.desktop`
    width: 25%;
  `};
`;

const PanelTitle = styled.div`
  font-size: 18px;
  font-weight: 500;
  line-height: 1.33;
  letter-spacing: 0.1px;
`;

const PanelContent = styled.div`
  background-color: #333;
  color: white;
  flex-grow: 1;
  margin-top: 12px;
  padding: 30px;

  h1,
  h2,
  h3,
  p {
    font-size: 16px;
    line-height: 1.25;
    letter-spacing: 0.1px;
    margin: 0 0 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const MarkdownStyle = styled.div`
  > p {
    font-size: 18px;
    line-height: 1.33;
    letter-spacing: 0.1px;
  }
`;

const TextPanelsSection = ({ entryId, title, description, panels }) => (
  <Section id={entryId} options={{ inner: { locked: true } }}>
    <Top>
      <Title>{title}</Title>
      <Description>{insertNewLine({ key: 'text-panel-section-1', description, component: MarkdownStyle })}</Description>
    </Top>

    <Panels>
      {panels.map((panel, index) => (
        <Panel key={generateKey('text-panels-section', index)}>
          <PanelTitle>{panel.title}</PanelTitle>
          {insertNewLine({ key: 'text-panel-section-2', description: panel.description, component: PanelContent })}
        </Panel>
      ))}
    </Panels>
  </Section>
);

TextPanelsSection.defaultProps = {
  entryId: undefined,
  description: undefined,
};

TextPanelsSection.propTypes = {
  entryId: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  panels: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default TextPanelsSection;



// WEBPACK FOOTER //
// ./src/components/Article/TextPanelsSection.js